module.exports = __webpack_public_path__ + "img/FAQ_mask.8de5a956.svg";